import { Box, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Schedule() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 4, maxWidth: '800px !important' }}>
      <Box sx={{ mb: 6 }}>
        {/* Schedule header section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: 2,
          mb: 4 
        }}>
          <Box sx={{ 
            bgcolor: 'rgba(225, 213, 203, 0.3)',
            p: 1,
            px: 2,
            borderRadius: 20,
            mb: 2,
            width: '100%'
          }}>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              📅 Schedule of Events
            </Typography>
          </Box>

          <Typography paragraph sx={{ mb: 2 }}>
            We're so excited for you to join us for our wedding celebration!
          </Typography>

          <Typography paragraph sx={{ mb: 0, fontStyle: 'italic' }}>
            All wedding events listed below are adults only.
          </Typography>
        </Box>

        {/* Welcome Drinks Section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: 2,
          mb: 4 
        }}>
          <Box sx={{ 
            bgcolor: 'rgba(225, 213, 203, 0.3)',
            p: 1,
            px: 2,
            borderRadius: 20,
            mb: 2,
            width: '100%'
          }}>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              🥂 Welcome Drinks
            </Typography>
          </Box>

          <Typography paragraph sx={{ mb: 2 }}>
            Join us for a welcome party at the Cactus Jack's Saloon & Grill!
          </Typography>

          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Friday, August 1st
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            6:00 PM - 8:00 PM
          </Typography>

          <Typography variant="body1" sx={{ mb: 1 }}>
            Cactus Jack's Saloon & Grill
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            4651 County Hwy 73, Evergreen, CO 80439
          </Typography>

          <Typography paragraph sx={{ mb: 1 }}>
            <Box component="span" sx={{ fontWeight: 'bold' }}>Dress:</Box> Casual attire
          </Typography>

          <Typography paragraph sx={{ mb: 3 }}>
            We will be serving light hors d'oeuvres, beer and wine.
          </Typography>
        </Box>

        {/* Wedding Ceremony & Reception Section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: 2,
          mb: 4 
        }}>
          <Box sx={{ 
            bgcolor: 'rgba(225, 213, 203, 0.3)',
            p: 1,
            px: 2,
            borderRadius: 20,
            mb: 2,
            width: '100%'
          }}>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              💍 Wedding Ceremony & Reception
            </Typography>
          </Box>

          <Typography variant="body1" sx={{ mb: 1 }}>
            Echo Mountain
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            19285 CO-103
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Idaho Springs, CO 80452
          </Typography>

          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Saturday, August 2nd
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            4:00 PM - 10:00 PM
          </Typography>

          <Typography paragraph sx={{ mb: 1 }}>
            <Box component="span" sx={{ fontWeight: 'bold' }}>Dress:</Box> Cocktail Attire
          </Typography>

          <Typography paragraph sx={{ mb: 3 }}>
            Please plan to arrive by 3:30 PM for the ceremony.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            onClick={() => navigate('/rsvp')}
            sx={{
              mt: 3,
              mb: 4,
              px: 8,
              py: 1.5,
              borderRadius: 25,
              fontFamily: '"Open Sans", sans-serif',
              backgroundColor: 'rgba(175, 99, 42, 1)',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'rgba(187, 138, 101, 1)',
              },
            }}
          >
            RSVP
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default Schedule;
